(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('[data-collection-slider]');
    
    sliders.forEach(slider => {
      const track = slider.querySelector('.collection-slider__track');
      const prevBtn = slider.querySelector('[data-slider-prev]');
      const nextBtn = slider.querySelector('[data-slider-next]');
      const cards = slider.querySelectorAll('.collection-slider__product-card');
      
      if (!track || cards.length === 0) return;
      
      let currentPosition = 0;
      const cardWidth = cards[0].offsetWidth;
      const gap = 24; // 1.5rem
      const scrollAmount = cardWidth + gap;
      
      function updatePosition() {
        track.style.transform = `translateX(-${currentPosition}px)`;
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          currentPosition = Math.max(0, currentPosition - scrollAmount);
          updatePosition();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const maxScroll = (cards.length - 1) * scrollAmount;
          currentPosition = Math.min(maxScroll, currentPosition + scrollAmount);
          updatePosition();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    // Mobile Menu Toggle
    const menuToggle = header.querySelector('[data-menu-toggle]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const menuClose = header.querySelector('[data-menu-close]');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        mobileMenu.classList.add('active');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
    }

    if (menuClose && mobileMenu) {
      menuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        menuToggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when clicking outside
    if (mobileMenu) {
      mobileMenu.addEventListener('click', (e) => {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('active');
          menuToggle?.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }

    // Mobile Submenu Toggle
    const submenuToggles = header.querySelectorAll('[data-mobile-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const item = toggle.closest('.header__mobile-nav-item');
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !isExpanded);
        item?.classList.toggle('active');
      });
    });

    // Desktop Dropdown Mega Menu with Backdrop
    const dropdownBackdrop = document.querySelector('[data-dropdown-backdrop]');
    const navItems = header.querySelectorAll('[data-dropdown-trigger]');
    const allDropdowns = document.querySelectorAll('.header__dropdown');
    
    if (dropdownBackdrop && navItems.length > 0) {
      let activeDropdown = null;
      let dropdownTimeout = null;

      // Function to set dropdown position
      const updateDropdownPosition = () => {
        const headerRect = header.getBoundingClientRect();
        const topPosition = headerRect.bottom;
        
        allDropdowns.forEach(dropdown => {
          dropdown.style.top = `${topPosition}px`;
        });
      };

      // Update position on load and scroll
      updateDropdownPosition();
      window.addEventListener('scroll', updateDropdownPosition);
      window.addEventListener('resize', updateDropdownPosition);

      const closeAllDropdowns = () => {
        document.querySelectorAll('.header__dropdown.active').forEach(dd => {
          dd.classList.remove('active');
        });
        dropdownBackdrop.classList.remove('active');
        activeDropdown = null;
      };

      navItems.forEach(navItem => {
        const dropdownId = navItem.getAttribute('data-dropdown-trigger');
        const dropdown = document.querySelector(`[data-dropdown-id="${dropdownId}"]`);
        
        if (dropdown) {
          // Mouse enter nav item
          navItem.addEventListener('mouseenter', () => {
            clearTimeout(dropdownTimeout);
            updateDropdownPosition(); // Update position before showing
            
            // Close any other open dropdown
            if (activeDropdown && activeDropdown !== dropdown) {
              activeDropdown.classList.remove('active');
            }
            
            // Open this dropdown
            dropdown.classList.add('active');
            dropdownBackdrop.classList.add('active');
            activeDropdown = dropdown;
          });

          // Mouse leave nav item
          navItem.addEventListener('mouseleave', (e) => {
            dropdownTimeout = setTimeout(() => {
              const dropdownRect = dropdown.getBoundingClientRect();
              const isOverDropdown = e.clientX >= dropdownRect.left && 
                                    e.clientX <= dropdownRect.right && 
                                    e.clientY >= dropdownRect.top && 
                                    e.clientY <= dropdownRect.bottom;
              
              if (!isOverDropdown) {
                dropdown.classList.remove('active');
                dropdownBackdrop.classList.remove('active');
                activeDropdown = null;
              }
            }, 150);
          });

          // Mouse enter dropdown - keep it open
          dropdown.addEventListener('mouseenter', () => {
            clearTimeout(dropdownTimeout);
            dropdown.classList.add('active');
            dropdownBackdrop.classList.add('active');
          });

          // Mouse leave dropdown - close it
          dropdown.addEventListener('mouseleave', () => {
            dropdownTimeout = setTimeout(() => {
              dropdown.classList.remove('active');
              dropdownBackdrop.classList.remove('active');
              activeDropdown = null;
            }, 150);
          });
        }
      });

      // Close dropdown when clicking backdrop
      dropdownBackdrop.addEventListener('click', closeAllDropdowns);

      // Close dropdowns on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && activeDropdown) {
          closeAllDropdowns();
        }
      });
    }

    // Search Toggle
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchOverlay = header.querySelector('[data-search-overlay]');
    const searchClose = header.querySelector('[data-search-close]');
    const searchInput = header.querySelector('.header__search-input');

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', () => {
        searchOverlay.classList.add('active');
        setTimeout(() => searchInput?.focus(), 100);
        document.body.style.overflow = 'hidden';
      });
    }

    if (searchClose && searchOverlay) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close search overlay when clicking outside
    if (searchOverlay) {
      searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) {
          searchOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    // Close search on Escape key
    if (searchOverlay) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
          searchOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    // Announcement Dismiss
    const announcement = document.querySelector('[data-announcement]');
    const announcementClose = document.querySelector('[data-announcement-close]');

    if (announcementClose && announcement) {
      announcementClose.addEventListener('click', () => {
        announcement.classList.add('hidden');
        localStorage.setItem('header-announcement-dismissed', 'true');
      });
    }

    // Check if announcement was previously dismissed
    if (announcement && localStorage.getItem('header-announcement-dismissed') === 'true') {
      announcement.classList.add('hidden');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('[data-hero-carousel]');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero-carousel__slide');
    const navItems = carousel.querySelectorAll('.hero-carousel__nav-item');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    
    let currentSlide = 0;
    let autoplayInterval;
    const autoplayDelay = 5000;

    function goToSlide(index) {
      slides[currentSlide].classList.remove('active');
      navItems[currentSlide]?.classList.remove('active');
      
      currentSlide = index;
      
      slides[currentSlide].classList.add('active');
      navItems[currentSlide]?.classList.add('active');
    }

    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      goToSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      goToSlide(prev);
    }

    function startAutoplay() {
      if (slides.length <= 1) return;
      autoplayInterval = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    // Navigation items
    navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        goToSlide(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    // Arrow controls
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        stopAutoplay();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        stopAutoplay();
        startAutoplay();
      });
    }

    // Pause on hover
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    });

    // Start autoplay
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
